import React from 'react';
import { useParams, Link } from 'react-router-dom';
import SEO from '../SEO';
import shastraCatalog from '../data/shastra_catalog.json';

const ShastraTopicDetailPage = () => {
  const { topicSlug } = useParams();
  const topics = shastraCatalog.topics || {};

  let foundItem = null;
  let mainTitle = '';

  Object.keys(topics).forEach((mainKey) => {
    const mainObj = topics[mainKey];
    const subObj = mainObj.sub_topics || {};
    if (subObj[topicSlug]) {
      foundItem = subObj[topicSlug];
      mainTitle = mainObj.main_topic_tamil;
    }
  });

  if (!foundItem) {
    return (
      <div style={{ maxWidth: '800px', margin: '60px auto', textAlign: 'center', padding: '40px 20px' }}>
        <SEO title="பக்கம் பெறப்படவில்லை - Ahobilam Shastra Library" />
        <h2 style={{ fontSize: '2rem', color: '#dc2626' }}>404 - சாஸ்திரப் பக்கம் பெறப்படவில்லை</h2>
        <p style={{ color: '#475569', margin: '20px 0' }}>தாங்கள் தேடிய சாஸ்திரத் தலைப்பிற்கான பக்கம் கண்டறியப்படவில்லை.</p>
        <Link to="/shastra-library" style={{ background: '#1e3a8a', color: '#ffffff', padding: '12px 24px', borderRadius: '8px', textDecoration: 'none', fontWeight: 'bold' }}>
          ⬅️ சாஸ்திர லைப்ரரிக்கு திரும்புக
        </Link>
      </div>
    );
  }

  const books = foundItem.books_opinion || {};

  // Schema.org JSON-LD Structured Data for Google Indexing
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://ahobilam.com/shastra-library/${topicSlug}`
    },
    headline: `${foundItem.sub_topic_tamil} - சாஸ்திர விதிகள் & நிர்ணயம்`,
    description: `${foundItem.sub_topic_tamil} பற்றிய தர்ம சிந்து, நிர்ணய சிந்து மற்றும் ஸ்ம்ருதி முக்தாபலம் நூல்களின் சாஸ்திர பூர்வ ஒப்பீட்டு நிர்ணய விதிகள்.`,
    author: {
      '@type': 'Organization',
      name: 'Ahobilam Vedic Library'
    },
    publisher: {
      '@type': 'Organization',
      name: 'Ahobilam.com',
      logo: {
        '@type': 'ImageObject',
        url: 'https://ahobilam.com/logo.png'
      }
    }
  };

  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '40px 20px', fontFamily: 'Arial, sans-serif' }}>
      <SEO
        title={`${foundItem.sub_topic_tamil} - தர்ம சிந்து, நிர்ணய சிந்து & ஸ்ம்ருதி முக்தாபலம் | Ahobilam.com`}
        description={`${foundItem.sub_topic_tamil} பற்றிய தர்ம சிந்து, நிர்ணய சிந்து மற்றும் ஸ்ம்ருதி முக்தாபலம் நூல்களின் சாஸ்திர பூர்வ ஒப்பீட்டு நிர்ணய விதிகள்.`}
        keywords={`${foundItem.sub_topic_tamil}, ${foundItem.keywords ? foundItem.keywords.join(', ') : ''}, தர்ம சிந்து, நிர்ணய சிந்து, ஸ்ம்ருதி முக்தாபலம், ஆஹ்நிக காண்டம், கால காண்டம், ஶ்ராத்த காண்டம், சாஸ்திர விதிகள், விரத நிர்ணயம், புண்ய காலம்`}
      />

      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>

      {/* Breadcrumb Navigation */}
      <nav style={{ marginBottom: '25px', fontSize: '0.95rem', color: '#64748b' }}>
        <Link to="/" style={{ color: '#166534', textDecoration: 'none' }}>முகப்பு</Link> {' > '}
        <Link to="/shastra-library" style={{ color: '#166534', textDecoration: 'none' }}>சாஸ்திர லைப்ரரி</Link> {' > '}
        <span style={{ color: '#1e3a8a', fontWeight: 'bold' }}>{foundItem.sub_topic_tamil}</span>
      </nav>

      {/* Main Header Banner */}
      <header style={{ background: 'linear-gradient(135deg, #1e3a8a 0%, #166534 100%)', padding: '35px 30px', borderRadius: '16px', color: '#ffffff', marginBottom: '35px', boxShadow: '0 8px 20px rgba(0,0,0,0.12)' }}>
        <span style={{ background: '#dcfce7', color: '#166534', padding: '5px 14px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: 'bold', textTransform: 'uppercase' }}>
          {mainTitle}
        </span>
        <h1 style={{ fontSize: '2.2rem', color: '#fef08a', margin: '15px 0 10px', lineHeight: '1.3' }}>
          {foundItem.sub_topic_tamil}
        </h1>
        <p style={{ color: '#e2e8f0', fontSize: '1.1rem', margin: 0 }}>
          தர்ம சாஸ்திர நூல்களின் (தர்ம சிந்து, நிர்ணய சிந்து & ஸ்ம்ருதி முக்தாபலம்) நேரடி ஒப்பீட்டு உரை மற்றும் கணித கால நிர்ணய விதிகள்.
        </p>
      </header>

      {/* Multi-Book Comparison Section */}
      <section style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
        <h2 style={{ fontSize: '1.6rem', color: '#1e3a8a', borderBottom: '3px solid #166534', paddingBottom: '8px', display: 'inline-block' }}>
          📖 தர்ம சாஸ்திர நூல்களின் தனித்தனி நிர்ணயம் (Book-by-Book Rules)
        </h2>

        {Object.keys(books).map((bookName) => {
          const opinion = books[bookName];
          return (
            <div
              key={bookName}
              style={{ background: '#f8fafc', borderRadius: '12px', borderLeft: '6px solid #1e3a8a', borderTop: '1px solid #e2e8f0', borderRight: '1px solid #e2e8f0', borderBottom: '1px solid #e2e8f0', padding: '25px', boxShadow: '0 4px 6px rgba(0,0,0,0.03)' }}
            >
              <h3 style={{ fontSize: '1.3rem', color: '#1e3a8a', marginTop: 0, marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                📜 {bookName}
              </h3>

              {typeof opinion === 'object' && opinion !== null ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                  {Object.keys(opinion).map((branchName) => (
                    <div key={branchName} style={{ background: '#ffffff', padding: '15px', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
                      <h4 style={{ color: '#166534', margin: '0 0 8px 0', fontSize: '1.05rem' }}>
                        🔸 {branchName}
                      </h4>
                      <p style={{ color: '#334155', margin: 0, lineHeight: '1.6', fontSize: '1rem' }}>
                        {opinion[branchName]}
                      </p>
                    </div>
                  ))}
                </div>
              ) : (
                <p style={{ color: '#334155', lineHeight: '1.7', fontSize: '1.05rem', margin: 0 }}>
                  {opinion}
                </p>
              )}
            </div>
          );
        })}
      </section>

      {/* Footer Navigation Back Button */}
      <footer style={{ marginTop: '50px', textAlign: 'center', borderTop: '1px solid #e2e8f0', paddingTop: '30px' }}>
        <Link
          to="/shastra-library"
          style={{ background: '#1e3a8a', color: '#ffffff', padding: '14px 28px', borderRadius: '30px', textDecoration: 'none', fontWeight: 'bold', fontSize: '1.05rem', boxShadow: '0 4px 10px rgba(0,0,0,0.15)' }}
        >
          ⬅️ சாஸ்திர லைப்ரரி அட்டவணைக்குத் திரும்பு
        </Link>
      </footer>
    </div>
  );
};

export default ShastraTopicDetailPage;
